<template>
  <v-container fluid>
    <v-row>
      <v-col></v-col>
      <v-col alin="end"> 
        <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search ..."
        single-line
        hide-details
      >
      </v-text-field> 
      </v-col>
    </v-row>
    <br/>
    <v-data-table
        dense
        :headers="headers"
        :items="bookingData"
        :options.sync="options"
        :search="search"
        class="elevation-1"
    >
      <template v-slot:item.wasteName="props">
        <v-edit-dialog
            @save="updateWasteType(props.item)"
            large
            persistent
        >
          {{ props.item.waste }}
          <template v-slot:input>
            <v-select
                :items="getWaste"
                v-model="props.item.wasteName"
                return-object
                item-text="name"
                label="Waste Type"
            ></v-select>
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:item.driver="props">
        <v-edit-dialog
            :return-value.sync="props.item.driver"
            @save="updateBookingDriver(props.item, props.item.driver)"
            large
            persistent
        >
          {{ props.item.driver.name }}
          <template v-slot:input>
            <v-select
                :items="props.item.drivers"
                v-model="props.item.driver"
                item-text="name"
                return-object
                label="Driver"
            ></v-select>
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:item.status="props">
        <v-edit-dialog
            @save="updateBookingStatus(props.item)"
            large
            persistent
        >
          {{ props.item.status.status }}
          <template v-slot:input>
            <v-select
                :items="statuses"
                v-model="props.item.type"
                item-text="type"
                return-object
                label="Status"
            ></v-select>
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:item.type="props">
        <v-edit-dialog
            @save="updateBookingType(props.item)"
            large
            persistent
        >
          {{ props.item.status.type }}
          <template v-slot:input>
            <v-select
                :items="types"
                v-model="props.item.type"
                item-text="type"
                return-object
                label="Type"
            ></v-select>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.action="{ item }">
      <v-icon
        small
        @click="deleteBooking(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    </v-data-table>
  </v-container>
</template>

<script>

export default {
  name: 'BookingsTable',
  props: {  
    bookings: Array
  },
  data() {
    return {
      headers: [
        { text: 'Id', value: 'id', filterable: true, sortable: true,},
        { text: 'Booking Number', value: 'orderNumber' },
        { text: 'Date', value: 'date' },
        { text: 'Waste', value: 'wasteName' },
        { text: 'Vehicle', value: 'vehicleName' },
        { text: 'Address', value: 'address' },
        { text: 'Status', value: 'status' },
        { text: 'Type', value: 'type' },
        { text: 'Driver', value: 'driver' },
        { text: 'Action', value: 'action' },
      ],
      bookingData: [],
      options: {
        page: 1,
        pageSize: 25
      },
      search: '',
      statuses: [],
      types: ['EXCHANGE', 'COLLECTION']
    }
  },
  computed: {
    getWaste(){
      return this.$store.getters['admin/getWaste'];
    },
    drivers() {
      return this.$store.getters['driver/getDrivers'];
    }
  },
  watch: {
    drivers() {
      if (this.bookingData.length === 0) {
        this.populateTableWithRichData();
      }
    }
  },
  methods: {
    updateWasteType(booking){
      this.$store.dispatch('admin/fetchWasteType', booking);
    },
    mapDrivers(driverIds) {
      return driverIds.map((driverId) => this.$store.getters['driver/getDriverById'](driverId));
    },
    updateBookingDriver(booking, driver) {
      this.$store.dispatch('admin/updateBooking', {
        id: booking.keyId,
        driver: driver
      });
    },
    updateBookingStatus(booking) {
     this.$store.dispatch('admin/updateBooking', {
       id: booking.keyId,
        status: {
          status: booking.type,
          type: booking.status.type
        }
       });
    },
    updateBookingType(booking) {
      if(booking.type == 'COLLECTION'){
        this.$store.dispatch('admin/updateToCollectionBooking', booking);
      }
      if(booking.type == 'EXCHANGE'){
        this.$store.dispatch('admin/updateToExchangeBooking', booking);
      }
    },
    async deleteBooking(booking){
      if(confirm(`Are you sure you want to delete order ${booking.id} ?`)){
        await this.$store.dispatch('admin/deleteBooking', booking);
      }
    },
    populateTableWithRichData() {
      this.bookings?.forEach((booking) => {
        this.bookingData.push({
          keyId: booking.id,
          id: booking.orderNumber.id,
          orderNumber: booking.orderNumber.number,
          date: booking.preferredDate,
          wasteName: booking.waste.name,
          waste: booking.waste.name,
          vehicleName: booking.vehicle.name,
          address: booking.capturedAddress,
          postCode: booking.postCode,
          parentBookingId: booking.parentBookingId ? booking.parentBookingId : '',
          status: {
            status: booking.status.status,
            type: booking.status.type
          },
          customer: booking.customer,
          drivers: this.mapDrivers(booking.drivers),
          driver: booking.driver ?? {}
        });
      });
      this.bookings.forEach((booking) => {
        if (booking.status.type === 'DELIVERY'){
          this.statuses = ['SCHEDULING', 'SCHEDULED', 'DROPPED'];
        }
        else{
          this.statuses = ['SCHEDULING', 'SCHEDULED', 'DISPOSING'];
        }
      })
    }
  },
  mounted () {
    this.populateTableWithRichData();
    this.$store.dispatch('admin/fetchWastes');
  }
}
</script>

<style scoped>

</style>